import { FC } from 'react';

import { options } from './switcherOptions';

import { ChartRangeOptionT } from 'types';

import './ChartRangeSwitcher.scss';

type Props = {
  selectedOption: ChartRangeOptionT;
  setSelectedOption: Function;
};

const ChartRangeSwitcher: FC<Props> = ({ selectedOption, setSelectedOption }) => {
  return (
    <div className="time-range-switcher">
      {options.map(option => (
        <div
          key={option.id}
          className={`switcher-option ${selectedOption.id === option.id ? 'active' : ''}`}
          onClick={() => setSelectedOption(option)}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
};

export default ChartRangeSwitcher;
